import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface DeviceViewItem {
  name: string;
  label: string;
  lastRecordedDate?: string;
  viewDisassociationAcknowledgedDate?: string;
}

export interface AuxDissociationView {
  name: string;
  viewDisassociationAcknowledgedDate: string;
}

export interface AuxDissociationRequest {
  views: AuxDissociationView[];
}

export interface DeviceViewEntry {
  serialNumber: string;
  type: string;
  views: DeviceViewItem[];
}

export interface DeviceViewRequest {
  followerSerialNumber: string;
  companyId: number;
  views: DeviceViewEntry[];
}

export interface DeviceViewResponse {
  serialNumber: string;
  followerSerialNumber: string;
  views: DeviceViewItem[];
}

@Injectable({
  providedIn: 'root',
})
export class DeviceViewService {
  private readonly baseUrl = environment.deviceView;

  constructor(private http: HttpClient) {}

  getDeviceViews(serialNumber: string): Observable<DeviceViewResponse> {
    return this.http.get<DeviceViewResponse>(
      `${this.baseUrl}/devices/${serialNumber}/views`
    );
  }

  updateDeviceViews(serialNumber: string, request: DeviceViewRequest): Observable<DeviceViewResponse> {
    return this.http.post<DeviceViewResponse>(
      `${this.baseUrl}/devices/${serialNumber}/views`,
      request
    );
  }

  dissociateAuxViews(serialNumber: string, request: AuxDissociationRequest): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/devices/v2/${serialNumber}/views/dissociate`,
      request
    );
  }
}
